export default __webpack_public_path__ + "static/media/background_image.3e8232ed.png";